import { h } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import ButtonControl from '../button-control'
import Editor from '../editor'

type Props = {
  subject: string,
  onSubjectChanged: (e: {target: HTMLInputElement}) => void,
  subjectError: string,
  content: string,
  onContentChanged: (content: string) => void,
  onEmailCreateDone: () => void
}

const CreateEmailForm = ({ subject, onSubjectChanged, subjectError, content, onContentChanged, onEmailCreateDone } : Props) => (
  <div className='create-email-campaign-form'>
    <InputGroup
      title='Subject'
      value={subject}
      onChange={onSubjectChanged}
      newStyle
      maxlength={250}
      error={subjectError}
      qaClasses='qa-create-email-subject'
    />
    <InputGroup
      title='Email design'
      newStyle
      customInput={
        <Editor
          profile='email'
          data={content}
          onChange={(content: string, attachments: string[], hasFileInProgress:boolean) => onContentChanged(content)}
          disableFileAttachments
          disableMentions
          isControl
        />
      }
    />
    <ButtonControl
      title='Done'
      variant='brand'
      newStyle
      size='medium'
      onClick={onEmailCreateDone}
      class='qa-create-email-done'
    />
  </div>
)

export default CreateEmailForm
